/**
 * Utility functions for authentication
 */

/**
 * Masks an email address for privacy
 * @param email - The email address to mask
 * @returns The masked email address
 */
export const maskEmail = (email: string): string => {
  const [localPart, domain] = email.split('@');
  const maskedLocal =
    localPart.length > 2
      ? localPart[0] + '*'.repeat(localPart.length - 2) + localPart[localPart.length - 1]
      : '*'.repeat(localPart.length);
  return `${maskedLocal}@${domain}`;
};

/**
 * Formats time remaining for countdown display
 * @param seconds - Number of seconds remaining
 * @returns Formatted time string
 */
export const formatCountdown = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (minutes > 0) {
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  return `${remainingSeconds}s`;
};
